
import './emailTemplates.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import zone from '../../service/zone';
import emailTemplate from '../../service/emailTemplate';

import menuLayout from '../../directive/menu-layout';
import customTable from '../../directive/custom-table';

import routing from './emailTemplates.routes';
import EmailTemplatesController from './emailTemplates.controller';

export default angular.module('page.emailTemplates', [
		uirouter,

		user,
		zone,
		emailTemplate,

		menuLayout,
		customTable
	])
	.config(routing)
	.controller('EmailTemplatesController', EmailTemplatesController)
	.name;



// WEBPACK FOOTER //
// ./src/page/emailTemplates/index.js